import React from "react";
import { Link, useLocation } from "react-router-dom";
import '../Css/componentes/footer.css';
import { FaFacebook, FaInstagram, FaLinkedin } from "react-icons/fa";

const Footer = () => {
  const location = useLocation();
  
  // Función para redirigir a una URL externa
  const redirectTo = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };
  
  // Función para manejar scroll cuando ya estamos en la misma página
  const handleSamePageScroll = (e) => {
    e.preventDefault();

    const scrollAmount = window.innerHeight * 0;
    
    window.scrollTo({
      top: scrollAmount,
      behavior: 'smooth'
    });
  };

  return (
    <footer>
      <div className="footer-container">
        <div className="footer-column logo-column">
          <h4 className="ft-desing">INVESTÍ PERÚ EIRL</h4>
          <p>Nos especializamos en ofrecer asesoría personalizada y desarrollo de tesis académicas con originalidad y rigor.</p>
          <hr></hr>
          <p className="ruc">RUC: 20612600113</p>
        </div>
        
        <div className="footer-column links-column">
          <h4 className="ft-desing">Links</h4>
          <nav>
            {location.pathname === "/about" ? (
              <a href="#" onClick={handleSamePageScroll}>Sobre Nosotros</a>
            ) : (
              <Link to="/about">Sobre Nosotros</Link>
            )}
            
            {location.pathname === "/servicios" ? (
              <a href="#" onClick={handleSamePageScroll}>Servicios</a>
            ) : (
              <Link to="/servicios">Servicios</Link>
            )}
            
            {location.pathname === "/contact" ? (
              <a href="#" onClick={handleSamePageScroll}>Contacto</a>
            ) : (
              <Link to="/contact">Contacto</Link>
            )}
            
            {location.pathname === "/testimonios" ? (
              <a href="#" onClick={handleSamePageScroll}>Testimonios</a>
            ) : (
              <Link to="/testimonios">Testimonios</Link>
            )}
          </nav>
        </div>

        <div className="footer-column contact-column">
          <h4 className="ft-desing">Contacto</h4>
          <div className="contact-info">
            <p>📧 bramos@investiperu.com</p>
            <p>📞 (+51) 927 365 498</p>
            <p>📍 Lima, Perú</p>
          </div>
        </div>
      </div>
      
      <div className="social-container">
        <div className="social-icons">
          <button className="icon-button" onClick={() => redirectTo("https://www.facebook.com/investiperu")}>
            <FaFacebook />
          </button>
          <button className="icon-button" onClick={() => redirectTo("https://www.instagram.com/investiperu")}>
            <FaInstagram />
          </button>
          <button className="icon-button" onClick={() => redirectTo("https://www.linkedin.com/company/investíeirl/")}>
            <FaLinkedin />
          </button>
        </div>
        <div className="footer-bottom">
          <p>© 2025 Todos los Derechos Reservados INVESTÍ PERÚ EIRL</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;